import { DOCS, PERMISSIONS } from 'components/Dashboard/constants';
import Styled from 'components/Dashboard/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import DocsAPI from 'services/apis/DocsAPI';

const Tab4Module = ({ userData, onUpdate, isAuth }) => {
  const { t } = useTranslation('dashboard');
  const history = useHistory();
  const [isActive, setIsActive] = useState(false);
  const [isIncomplete, setIsIncomplete] = useState(false);
  const [docs, setDocs] = useState({
    verified: [],
    pending: [],
    reject: [],
    notUploaded: []
  });
  const localDocsAPI = new DocsAPI();

  useEffect(() => {
    onGetDocsStatus();
    if (isActive !== isAuth) setIsActive(isAuth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, isAuth]);

  useEffect(() => {
    if (!isActive && userData.authStep !== 'PRE_BUY_STOCK')
      setIsIncomplete(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  const onHandleAction = () =>
    isActive
      ? [...docs.notUploaded, ...docs.reject].length > 0
        ? history.push('/authentication/')
        : userData?.permissions.includes(PERMISSIONS[1])
        ? history.push('/dashboard/')
        : history.push('/stock/')
      : history.push('/authentication/');

  const onGetDocsStatus = () => {
    localDocsAPI.fetchStatus().then(response => {
      if (response) {
        const _uploaded = [
          ...response.pendingDocs,
          ...response.verifiedDocs
        ].map(_doc => _doc.docType);
        const _DOCS =
          userData.accountType !== 'Natural' ? DOCS.legal : DOCS.personal;

        setDocs({
          ...docs,
          verified: response.verifiedDocs,
          pending: response.pendingDocs,
          reject: response.rejectDocs,
          notUploaded: _DOCS
            .filter(_doc => !_uploaded.includes(_doc))
            .map(_doc => ({ docType: _doc }))
        });
      }
    });
  };

  return (
    <>
      <Styled.Box equal={true}>
        <Styled.Spacer size={10} />
        <Styled.Content bar={true} space={100} isTop={true}>
          <Styled.FingerPrint isActive={isActive}>
            {/* <div className={'badge'}>
              {!isActive ? (
                <svg viewBox="0 0 5 19">
                  <path d="M1.12273 12.5573L0.424515 5.05655V0.897217H4.35444V5.05655L3.83577 12.5573H1.12273ZM2.4194 13.6346L4.63372 15.8489L2.4194 18.0632L0.205078 15.8489L2.4194 13.6346Z" />
                </svg>
              ) : (
                <svg viewBox="0 0 15 12">
                  <path d="M14.6308 0.371635C15.1231 0.867397 15.1231 1.67103 14.6308 2.16654L6.17624 10.681C5.68395 11.1765 4.8862 11.1765 4.39391 10.681L0.369216 6.62765C-0.123072 6.13214 -0.123072 5.32851 0.369216 4.83299C0.861257 4.33723 1.65926 4.33723 2.1513 4.83299L5.28495 7.98876L12.8485 0.371635C13.3407 -0.123878 14.1387 -0.123878 14.6308 0.371635Z" />
                  <defs>
                    <linearGradient id="gradient">
                      <stop stopColor="#8055FA" />
                      <stop offset="1" stopColor="#EE61BB" />
                    </linearGradient>
                  </defs>
                </svg>
              )}
            </div> */}
            <svg viewBox="0 0 59 68">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.1011 55.3121C19.1957 59.1651 20.5943 60.8241 23.0974 63.4192C23.2486 63.5743 23.3684 63.7589 23.4495 63.9623C23.5307 64.1657 23.5717 64.3838 23.5701 64.6037C23.5686 64.8236 23.5244 65.041 23.4404 65.2431C23.3563 65.4453 23.2339 65.6281 23.0805 65.7809C22.9401 65.9435 22.767 66.0727 22.5734 66.1595C22.3798 66.2463 22.1701 66.2887 21.959 66.2838C21.7438 66.2835 21.5309 66.2389 21.3327 66.1525C21.1345 66.0662 20.9551 65.9398 20.805 65.7809C17.9949 62.8492 16.4675 60.9904 14.274 56.9536C12.0311 52.8324 10.8446 47.7911 10.8446 42.3971C10.8446 32.446 19.0994 24.3389 29.2563 24.3389C39.4119 24.3389 47.6667 32.4299 47.6667 42.3971C47.6667 43.3185 46.9355 44.0722 46.0404 44.0722C45.148 44.0722 44.4168 43.3185 44.4168 42.3958C44.4168 34.29 37.6243 27.6891 29.255 27.6891C20.9026 27.6891 14.0945 34.2887 14.0945 42.3971C14.0945 47.2211 15.1353 51.6777 17.0998 55.3121H17.1011ZM29.1418 16.1822C43.9133 16.1822 55.9371 27.9573 55.9371 42.4306C55.9371 47.8756 51.4357 52.2973 45.9273 52.2973C40.4188 52.2973 35.9174 47.8742 35.9174 42.4306C35.9174 38.8458 32.8783 35.9141 29.1574 35.9141C25.4366 35.9141 22.3974 38.8284 22.3974 42.4306C22.3974 48.1425 24.5584 53.519 28.4757 57.5397C31.546 60.6886 34.537 62.4308 39.1178 63.7209C39.9804 63.9717 40.5008 64.893 40.2562 65.7809C40.0611 66.5185 39.4106 67.004 38.6963 67.004C38.5526 67.0077 38.4095 66.985 38.2735 66.9369C33.0903 65.4791 29.7103 63.5037 26.2003 59.9014C23.9619 57.6124 22.1873 54.8876 20.9794 51.8853C19.7716 48.8831 19.1546 45.6634 19.1645 42.4132C19.1645 36.9683 23.649 32.5479 29.1743 32.5479C34.6997 32.5479 39.1842 36.9696 39.1842 42.4132C39.1842 45.998 42.2233 48.9297 45.9442 48.9297C49.665 48.9297 52.7041 46.0155 52.7041 42.4132C52.7041 29.7839 42.1414 19.5149 29.1574 19.5149C19.9112 19.5149 11.4782 24.8083 7.67537 33.016C6.4082 35.7304 5.77461 38.8954 5.77461 42.4132C5.77461 45.027 6.00229 49.147 7.93557 54.4913C8.08405 54.9089 8.06662 55.3699 7.88707 55.7743C7.70751 56.1786 7.38035 56.4935 6.97673 56.6505C6.57187 56.8037 6.12473 56.7859 5.73251 56.6011C5.34029 56.4162 5.03469 56.0793 4.88213 55.6635C3.28841 51.2579 2.50781 46.9368 2.50781 42.4132C2.50781 38.3939 3.25458 34.742 4.73252 31.577C9.07264 22.2294 18.6597 16.1809 29.1405 16.1809L29.1418 16.1822Z"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.1858 8.07378C16.7592 4.94227 22.8375 3.35036 29.2878 3.35036C35.7551 3.35036 41.1659 4.77463 47.3912 8.09122C47.6345 8.20789 47.8778 8.27495 48.138 8.27495C48.7234 8.27495 49.292 7.93967 49.5847 7.37104C49.7816 6.97524 49.8187 6.51521 49.6878 6.09134C49.5569 5.66747 49.2687 5.31418 48.886 5.10857C42.2562 1.57472 36.2104 0.000244141 29.2878 0.000244141C22.3015 0.000244141 15.6872 1.72626 9.62588 5.126C9.24694 5.33967 8.96566 5.69953 8.84371 6.12667C8.72177 6.55381 8.76912 7.01336 8.97538 7.40456C9.18266 7.79555 9.53199 8.08577 9.94666 8.21149C10.3613 8.33722 10.8075 8.28817 11.1871 8.07512L11.1858 8.07378Z"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M58.2125 23.1173C54.9782 18.4596 50.884 14.8078 46.0248 12.2275C35.7872 6.80129 22.7239 6.81872 12.502 12.2623C7.62716 14.8587 3.51602 18.5441 0.298653 23.234C-0.221745 23.9877 -0.043509 25.0258 0.688952 25.5622C0.980375 25.7634 1.30562 25.864 1.63087 25.864C2.13436 25.864 2.63784 25.6293 2.96309 25.1773C5.80401 20.9917 9.59104 17.5822 13.9968 15.2436C23.3081 10.2855 35.2187 10.2681 44.5468 15.2101C48.9338 17.5222 52.639 20.8388 55.5637 25.0606C56.0841 25.8143 57.108 25.982 57.8391 25.4455C58.5703 24.9091 58.7329 23.8711 58.2125 23.1173ZM48.6411 56.4173C47.5192 56.6165 46.3838 56.7228 45.2455 56.7352C41.9956 56.7352 39.2973 55.948 37.0063 54.3399C33.0577 51.5772 30.7016 47.1207 30.7016 42.4134C30.7016 41.492 29.9705 40.7383 29.0767 40.7383C28.1829 40.7383 27.4504 41.492 27.4504 42.4147C27.4504 48.2432 30.3439 53.7378 35.1706 57.1214C37.9807 59.0808 41.3776 60.0853 45.2455 60.0853C45.7008 60.0853 47.3088 60.0692 49.2096 59.7178C49.6336 59.6384 50.0099 59.3894 50.2565 59.0251C50.5032 58.6609 50.6001 58.2108 50.5262 57.7732C50.4485 57.3369 50.2069 56.9499 49.8539 56.6962C49.5009 56.4426 49.065 56.3428 48.6411 56.4187V56.4173Z"
              />
              <defs>
                <linearGradient id="gradient">
                  <stop stopColor="#7F55FA" />
                  <stop offset="1" stopColor="#F461B7" />
                </linearGradient>
              </defs>
            </svg>
          </Styled.FingerPrint>
          <Styled.AuthContent>
            <Styled.Spacer size={15} />
            {[...docs.pending, ...docs.verified].length > 0 && (
              <div className={'uploaded'}>
                <div className={'title'}>{t('docs.uploaded')}</div>
                {[...docs.pending, ...docs.verified].map((_doc, _index) => (
                  <div className={'item'} key={`doc_item_${_index}`}>
                    {t(
                      `docs${
                        userData.accountType !== 'Natural' ? '.legal' : ''
                      }.${_doc.docType}`
                    )}
                  </div>
                ))}
              </div>
            )}
            {[...docs.notUploaded, ...docs.reject].length > 0 && (
              <div className={'uploaded not'}>
                <div className={'title'}>{t('docs.not_uploaded')}</div>
                {[...docs.notUploaded, ...docs.reject].map((_doc, _index) => (
                  <div className={'item'} key={`doc_not_item_${_index}`}>
                    {t(
                      `docs${
                        userData.accountType !== 'Natural' ? '.legal' : ''
                      }.${_doc.docType}`
                    )}
                  </div>
                ))}
              </div>
            )}
          </Styled.AuthContent>
        </Styled.Content>

        {[
          ...docs.notUploaded,
          ...docs.reject,
          ...docs.pending,
          ...docs.verified
        ].length > 0 && (
          <Styled.AuthAction
            isEnd={true}
            isActive={false}
            onClick={onHandleAction}
          >
            {isActive
              ? [...docs.notUploaded, ...docs.reject].length > 0
                ? t('docs.action.complete')
                : userData?.permissions.includes(PERMISSIONS[1])
                ? t('docs.action.stocks')
                : t('docs.action.prebuy')
              : isIncomplete
              ? t('auth.action.continue')
              : t('auth.action.begin')}
          </Styled.AuthAction>
        )}
        <Styled.Spacer size={10} />
      </Styled.Box>
    </>
  );
};

export default Tab4Module;
